import { CtxRendererProps, PieNodeDataProps } from "./@types";
import { RootNodeRendererProps } from "../graph-explorer/@types";

const slicePercentage = (
  value: number,
  totalValue: number,
  minPercentage = 0.02
) => {
  if (value === 0) return 0;
  return Math.max(value / totalValue, minPercentage);
};

export const rootNodeRenderer =
  ({ size, label, imgInst }: RootNodeRendererProps) =>
  ({ ctx, x, y }: CtxRendererProps) => ({
    drawNode: () => {
      ctx.strokeStyle = "darkgray"; // circle color
      ctx.lineWidth = 3; // circle outline thickness

      ctx.beginPath();
      ctx.arc(x, y, size / 2 + 40, 0, Math.PI * 2);
      ctx.stroke();
      ctx.fillStyle = "rgba(255,255,255,0)";
      ctx.fill();
      ctx.drawImage(imgInst, x - size / 2, y - size / 2, size, size);
    },
    drawExternalLabel: () => {
      ctx.fillStyle = "black";
      ctx.textAlign = "center";
      ctx.fillText(label, x, y + size / 2 + 10);
    },
    nodeDimensions: {
      width: size,
      height: size
    } // pie bounding box
  });
export const pieNodeCtxRenderer =
  ({ points, total, label, radius }: PieNodeDataProps) =>
  ({ ctx, x, y }: CtxRendererProps) => ({
    drawNode: () => {
      const totalValue = points.reduce(
        (sum, point) => sum + parseInt(String(point.value), 10),
        0
      );
      let startAngle = 0;
      for (let i = 0; i < points.length; i++) {
        const point = points[i];
        const endAngle =
          startAngle + 2 * Math.PI * slicePercentage(point.value, totalValue);

        ctx.beginPath();
        ctx.moveTo(x, y);
        ctx.arc(x, y, radius, startAngle, endAngle, false);
        ctx.closePath();
        ctx.fillStyle = point.fill; // color of the chart chunk
        ctx.fill();

        startAngle = endAngle;
      }

      // inner circle
      ctx.beginPath();
      ctx.moveTo(x, y);
      ctx.arc(x, y, radius - 25, 0, 2 * Math.PI, false);
      ctx.closePath();
      ctx.fillStyle = "white"; // inner chunk
      ctx.fill();
    },
    drawExternalLabel: () => {
      const fontSize = 36;
      const fontArgs = ctx.font.split(" ");
      ctx.font = `bold ${fontSize}px ${fontArgs[fontArgs.length - 1]}`;
      const totalLabel = `${window.tcbase.formatNumber(total, true)}`;
      const totalLabelWidth = ctx.measureText(totalLabel).width;

      // total label
      ctx.fillStyle = "black";
      ctx.fillText(totalLabel, x - totalLabelWidth / 2, y + radius + fontSize);

      // node name label
      ctx.font = `${fontSize}px ${fontArgs[fontArgs.length - 1]}`;
      const labelWidth = ctx.measureText(label).width;
      ctx.fillText(label, x - labelWidth / 2 + 2, y + radius + 2 * fontSize);
    },
    nodeDimensions: {
      width: radius * 2,
      height: radius * 2
    } // pie bounding box
  });
